<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Our Journey table</h6>
      </div>
      <div class="float-end">
        <div class="row">
          <!-- <div class="col-12">
            <div class="input-group mb-3">
              <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari" name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari">
              <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%;" type="button" id="cari" @click="cari"><i class="fas fa-search"></i></button>
            </div>
          </div> -->
          <div class="col-6">
            <button class="btn btn-sm btn-dark me-2" @click="showModal = true">
              <i class="fa fa-plus"></i> Add
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{ alertstatus }}</strong> {{ alerttext }}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Icon
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Title
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Number
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Action
              </th>

            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>
                <img :src="item?.icon" alt="" srcset="" class="img-fluid" style="max-width: 15%;">
              </td>
              <td>
                {{ item?.title }}
              </td>
              <td>
                {{ item?.number }}
              </td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i
                    class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i
                    class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item prev :disabled="currentPage === 1" @click="prevPage" />

          <!-- Page Numbers -->
          <argon-pagination-item v-for="page in totalPages" :key="page" :label="String(page)"
            :active="currentPage === page" @click="setPage(page)" />

          <!-- Next Page Button -->
          <argon-pagination-item next :disabled="currentPage === totalPages" @click="nextPage" />
        </argon-pagination>
      </div>

      <div :class="showModal == true ? 'modal-backdrop' : ''"></div>
      <div class="modal fade" :class="showModal == true ? 'show' : ''" tabindex="-1" aria-labelledby="modalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add'">Add New Our Journey</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit Our Journey</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3">
                  <label for="title" class="form-label">Title</label>
                  <input type="text" id="title" class="form-control" v-model="formData.title" required>
                </div>
                <div class="mb-3">
                  <label for="number" class="form-label">Number</label>
                  <input type="text" id="number" class="form-control" v-model="formData.number" required>
                  <!-- <input type="text" id="number" class="form-control" v-model="formData.number" @keypress="validateInput($event)" required> -->
                </div>
                <div class="mb-3">
                  <label for="option_content" class="form-label">Pilih Icon</label>
                  <div class="icon-radio-group">
                    <label v-for="(icon, idx) in iconList" :key="idx" class="icon-radio">
                      <input type="radio" :value="icon.icon" v-model="formData.icon" required />
                      <img :src="icon.icon" :alt="icon.name" class="icon-image" />
                      <span>{{ icon.name }}</span>
                    </label>
                  </div>

                  <!-- Pratinjau Ikon yang Dipilih -->
                  <div class="mt-2">
                    <p>Ikon Terpilih:</p>
                    <img :src="formData.icon" alt="Selected Icon" v-if="formData.icon"
                      style="width: 40px; height: 40px;" />
                  </div>
                </div>

                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button class="btn btn-primary btn-sm" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    <span v-if="!loading">Submit</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

</template>
<script>
import api from "@/utils/api";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";


export default {
  data() {
    return {
      loading: false,
      our_journeyList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage: 10,
      sortOrder: 'asc',
      searchQuery: '',
      showModal: false, // Controls modal visibility
      formData: {
        title: '',
        icon: '',
        number: '',
      },
      method: 'add',
      alertstatus: null,
      alerttext: null,
      iconList: [
        { name: "Icon 1", icon: "/icons/01.png" },
        { name: "Icon 2", icon: "/icons/02.png" },
        { name: "Icon 3", icon: "/icons/03.png" },
        { name: "Icon 4", icon: "/icons/04.png" },
        { name: "Icon 5", icon: "/icons/05.png" },
        { name: "Icon 6", icon: "/icons/06.png" },
        { name: "Icon 7", icon: "/icons/07.png" },
        { name: "Icon 8", icon: "/icons/08.png" },
        { name: "Icon 9", icon: "/icons/09.png" },
        { name: "Icon 10", icon: "/icons/10.png" },
        { name: "Icon 11", icon: "/icons/11.png" },
        { name: "Icon 12", icon: "/icons/12.png" },
        { name: "Icon 13", icon: "/icons/13.png" },
        { name: "Icon 14", icon: "/icons/14.png" },
        { name: "Icon 15", icon: "/icons/15.png" },
        { name: "Icon 16", icon: "/icons/16.png" },
        { name: "Icon 17", icon: "/icons/17.png" },
        { name: "Icon 18", icon: "/icons/18.png" },
        { name: "Icon 19", icon: "/icons/19.png" },
        { name: "Icon 20", icon: "/icons/20.png" },
        { name: "Icon 21", icon: "/icons/21.png" },
        { name: "Icon 22", icon: "/icons/22.png" },
        { name: "Icon 23", icon: "/icons/23.png" },
        { name: "Icon 24", icon: "/icons/24.png" },
        { name: "Icon 25", icon: "/icons/25.png" },
      ],
    };
  },
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonAlert,
  },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchour_journeyList();
  },
  computed: {
    totalItems() {
      return this.our_journeyList.length;
    },
    paginatedData() {
      return this.our_journeyList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchour_journeyList() {
      const config = {
        method: "get",
        url: "/admin/our_journey",

      };

      await api[config.method](config.url)
        .then((response) => {
          if (response.data?.message == 'success') {
            this.our_journeyList = response.data?.data; // Assign banner_list to local data
            this.totalPages = 1 // Update the total number of pages (this depends on how the API returns pagination info)
          } else {
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchour_journeyList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchour_journeyList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchour_journeyList();
    },
    updateItemsPerPage() {
      this.fetchour_journeyList();
    },
    updatesoftby() {
      this.fetchour_journeyList();
    },
    cari() {
      this.fetchour_journeyList();
    },
    closeModal() {
      this.showModal = false;
      // Reset form data
      this.formData = {
        title: '',
        file: null,
      };
      this.method = 'add';
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    handleFileUpload(event) {
      this.formData.file = event.target.files[0]; // Capture the file
    },
    async submitForm() {
      var data = {};
      var config = {};

      this.loading = true;

      if (!this.formData.icon) {
        this.$swal({
          title: "Warning!",
          text: "Pilih icon dulu!",
          icon: "warning"
        });
        return
      }

      if (this.method == 'add') {
        data = {
          'icon': this.formData.icon,
          'number': this.formData.number,
          'title': this.formData.title
        }

        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/admin/our_journey',

        };
      } else {
        data = {
          'icon': this.formData.icon,
          'number': this.formData.number,
          'title': this.formData.title
        }
        config = {
          method: 'put',
          maxBodyLength: Infinity,
          url: '/admin/our_journey/' + this.formData.id,

        }
      }

      try {
        const response = await api[config.method](config.url, data);
        if (response.data?.message == 'success') {
          this.fetchour_journeyList();
          if (this.method == 'add') {
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success"
            });
          }
          this.closeModal(); // Close modal after successful submission
        } else {
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
      } catch (error) {
        var err = error.response.data.data

        this.$swal({
          title: error.response.data.message,
          text: err,
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
      } finally {
        this.loading = false;
      }
    },

    async hapus(id) {
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: '/admin/our_journey/' + id,

        };

        try {
          const response = await api[config.method](config.url);
          if (response.data?.message == 'success') {
            await this.fetchour_journeyList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },

    edit(item) {
      this.formData = {
        number: item.number,
        icon: item.icon,
        title: item.title,
        id: item.id
      };
      this.showModal = true;
      this.method = 'edit';
    },
    validateInput(event) {
      const key = event.key;
      // Allow only digits and backspace
      if (!/[0-9\b]/.test(key)) {
        event.preventDefault();
      }

    },

  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block;
  /* Override display to block */
}

.modal-backdrop {
  opacity: 50%;
}
</style>